// extracted by mini-css-extract-plugin
export var helpCenterArticleTemplate__cardImage = "help-center-article-module--help-center-article-template__card-image--a304c";
export var helpCenterArticleTemplate__share = "help-center-article-module--help-center-article-template__share--371be";
export var mt0 = "help-center-article-module--mt-0--aa1a4";
export var mt1 = "help-center-article-module--mt-1--ccb07";
export var mt2 = "help-center-article-module--mt-2--0158f";
export var mt3 = "help-center-article-module--mt-3--8f186";
export var mt4 = "help-center-article-module--mt-4--910ca";
export var mt5 = "help-center-article-module--mt-5--482a4";
export var mt6 = "help-center-article-module--mt-6--fe527";